import React from 'react';
import {
  IconServer,
  IconShield,
  IconUsers
} from '@tabler/icons-react';

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 bg-white dark:bg-dark-900 border-t border-b border-gray-300 dark:border-dark-800 transition-colors duration-300">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Заголовок */}
        <div className="text-center max-w-[600px] mx-auto mb-12">
          <p className="text-[13px] font-semibold text-primary-500 uppercase tracking-[2px] mb-4">
            Как это работает
          </p>
          <h2 className="text-[28px] sm:text-[32px] lg:text-[40px] font-bold text-gray-900 dark:text-white mb-4 tracking-[-0.5px]">
            Как работает Xneon Connect
          </h2>
          <p className="text-lg text-gray-700 dark:text-dark-500">
            Клиент подключается к нашему серверу, получает публичный IP, друзья заходят к тебе в игру через этот адрес.
          </p>
        </div>

        {/* Диаграмма */}
        <div className="mt-12">
          <div className="flex flex-col md:flex-row items-center justify-center gap-0 p-8 md:p-10 bg-gray-50 dark:bg-dark-950 border border-gray-300 dark:border-dark-800 rounded-2xl relative overflow-hidden">
            
            {/* Твой сервер */}
            <div className="flex flex-col items-center text-center p-4 sm:p-6 bg-white dark:bg-dark-900 border border-gray-300 dark:border-dark-800 rounded-xl min-w-[140px] sm:min-w-[180px] transition-all hover:border-gray-400 dark:hover:border-dark-700 hover:-translate-y-0.5">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center mb-3 sm:mb-4">
                <IconServer className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
              </div>
              <div className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">Твой сервер</div>
              <div className="text-[11px] sm:text-[13px] text-gray-600 dark:text-dark-500 mb-2 sm:mb-3">Minecraft / Game Server</div>
              <div className="text-[10px] sm:text-xs font-mono bg-gray-200 dark:bg-dark-800 px-2 sm:px-2.5 py-1 rounded-md text-gray-700 dark:text-dark-400">
                localhost
              </div>
            </div>

            {/* Стрелка 1 */}
            <div className="flex flex-col items-center py-4 md:py-0 md:px-2">
              <div className="w-3 md:w-20 h-20 md:h-[3px] bg-gray-300 dark:bg-dark-800 rounded relative overflow-hidden md:rotate-0 rotate-90">
                <div className="absolute top-0 left-0 md:left-[-30px] w-[30px] h-full md:w-[30px] md:h-full bg-gradient-to-r from-transparent via-primary-500 to-transparent animate-pulse-arrow" />
              </div>
              <div className="text-[11px] text-gray-600 dark:text-dark-600 mt-2 whitespace-nowrap hidden md:block">Защищённый туннель</div>
            </div>

            {/* XN Connect */}
            <div className="flex flex-col items-center text-center p-5 sm:p-7 bg-gradient-to-b from-primary-500/10 to-white dark:to-dark-900 border-2 border-primary-500 rounded-xl min-w-[160px] sm:min-w-[200px]">
              <div className="w-14 h-14 sm:w-[72px] sm:h-[72px] bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center mb-3 sm:mb-4">
                <IconShield className="w-7 h-7 sm:w-9 sm:h-9 text-white" />
              </div>
              <div className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">XN Connect</div>
              <div className="text-[11px] sm:text-[13px] text-gray-600 dark:text-dark-500 mb-2 sm:mb-3">Публичный реверс прокси</div>
              <div className="flex gap-1 sm:gap-1.5 flex-wrap justify-center">
                <span className="text-[10px] sm:text-[11px] bg-primary-500/15 text-primary-500 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded font-medium">Публичный IP</span>
                <span className="text-[10px] sm:text-[11px] bg-primary-500/15 text-primary-500 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded font-medium">Туннель</span>
              </div>
            </div>

            {/* Стрелка 2 */}
            <div className="flex flex-col items-center py-4 md:py-0 md:px-2">
              <div className="w-3 md:w-20 h-20 md:h-[3px] bg-gray-300 dark:bg-dark-800 rounded relative overflow-hidden md:rotate-0 rotate-90">
                <div className="absolute top-0 left-0 md:left-[-30px] w-[30px] h-full md:w-[30px] md:h-full bg-gradient-to-r from-transparent via-primary-500 to-transparent animate-pulse-arrow" style={{ animationDelay: '1s' }} />
              </div>
              <div className="text-[11px] text-gray-600 dark:text-dark-600 mt-2 whitespace-nowrap hidden md:block">Чистый трафик</div>
            </div>

            {/* Игроки */}
            <div className="flex flex-col items-center text-center p-4 sm:p-6 bg-white dark:bg-dark-900 border border-gray-300 dark:border-dark-800 rounded-xl min-w-[140px] sm:min-w-[180px] transition-all hover:border-gray-400 dark:hover:border-dark-700 hover:-translate-y-0.5">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-xl flex items-center justify-center mb-3 sm:mb-4">
                <IconUsers className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
              </div>
              <div className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">Игроки</div>
              <div className="text-[11px] sm:text-[13px] text-gray-600 dark:text-dark-500 mb-2 sm:mb-3">Подключаются к прокси</div>
              <div className="text-[10px] sm:text-xs font-mono bg-gray-200 dark:bg-dark-800 px-2 sm:px-2.5 py-1 rounded-md text-gray-700 dark:text-dark-400">
                connect.xneon.org
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
